function isProductRecommendation(recommendation) {
    return recommendation.recommendationType === 'product';
}
function isBannerRecommendation(recommendation) {
    return recommendation.recommendationType === 'banner';
}

export { isBannerRecommendation, isProductRecommendation };
//# sourceMappingURL=guards.js.map
